export default __webpack_public_path__ + "../staticImages/img-sprite-2x.png";